const DASHBOARD_LOCALE_MAP = {
  cz: "cs-CZ",
  en: "en-US",
};

export function resolveDashboardLocale(language) {
  const normalizedLanguage = language?.toLowerCase();

  if (!normalizedLanguage) {
    return Intl.DateTimeFormat().resolvedOptions().locale || "en-US";
  }

  return DASHBOARD_LOCALE_MAP[normalizedLanguage] ?? language;
}

export function parseDashboardDate(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function formatDashboardDate(value, language, options) {
  const date = parseDashboardDate(value);

  if (!date) {
    return value ?? "";
  }

  return new Intl.DateTimeFormat(resolveDashboardLocale(language), options).format(date);
}

export function formatDashboardDateRange(
  fromDate,
  toDate,
  language,
  fallbackLabel,
  options = {
    month: "short",
    day: "numeric",
    year: "numeric",
  }
) {
  const from = parseDashboardDate(fromDate);
  const to = parseDashboardDate(toDate);

  if (!from || !to) {
    return fallbackLabel;
  }

  const formatter = new Intl.DateTimeFormat(resolveDashboardLocale(language), options);
  return `${formatter.format(from)} - ${formatter.format(to)}`;
}

function createUtcHourDate(hour, referenceValue) {
  const referenceDate = parseDashboardDate(referenceValue) ?? new Date();

  return new Date(
    Date.UTC(
      referenceDate.getUTCFullYear(),
      referenceDate.getUTCMonth(),
      referenceDate.getUTCDate(),
      hour,
      0,
      0,
      0
    )
  );
}

export function localizeHourlyBuckets(hourlyBuckets, language, referenceValue) {
  const locale = resolveDashboardLocale(language);
  const hourFormatter = new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
  });

  return hourlyBuckets
    .map((bucket) => {
      const localDate = createUtcHourDate(bucket.hour, referenceValue);

      return {
        ...bucket,
        localHour: localDate.getHours(),
        label: hourFormatter.format(localDate),
      };
    })
    .sort((left, right) => left.localHour - right.localHour);
}
